import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData } from "../../helpers/fackBackend_Helper";

function* getChatrActivationReportResponse({ payload: { searchData } }) {
  try {
    const response = yield call(
      addData,
      "/chatrActivationReportList",
      searchData,
    );
    if (response?.response?.Status) {
      yield put(
        actions.getChatrActivationReportRequestListSuccessful(
          response?.response?.data,
        ),
      );
    } else {
      yield put(
        actions.getChatrActivationReportRequestListFailed(
          response?.response?.Message,
        ),
      );
    }
  } catch (error) {
    yield put(actions.getChatrActivationReportRequestListFailed(error));
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST,
      getChatrActivationReportResponse,
    ),
  ]);
}
